exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".RichTextEditor-2cd053ea{position:relative;min-height:100px}\n", ""]);

// Exports
exports.locals = {
	"RichTextEditor": "RichTextEditor-2cd053ea"
};